import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Box from './Box';
var Flex = forwardRef(function (_ref, ref) {
  var align = _ref.align,
      justify = _ref.justify,
      wrap = _ref.wrap,
      direction = _ref.direction,
      rest = _objectWithoutProperties(_ref, ["align", "justify", "wrap", "direction"]);

  return React.createElement(Box, _extends({
    ref: ref,
    display: "flex",
    flexDirection: direction,
    alignItems: align,
    justifyContent: justify,
    flexWrap: wrap
  }, rest));
});
Flex.propTypes = {
  align: PropTypes.string,
  justify: PropTypes.string,
  wrap: PropTypes.string,
  direction: PropTypes.string
};
Flex.displayName = 'Flex';
export default Flex;